<template>
  <div class="unauthorized">
    <h2>You are not authorized to view this page. If you think this is incorrect, please contact the system administrator</h2>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized'
}
</script>


// WEBPACK FOOTER //
// Unauthorized.vue?4c7dda89